import './index.css';
import '../index.css';
import './targetvalidation.css';
import EditableResultRadio from '../../../components/EditableResultRadio';
import circle from '../../../assets/shapes_svg/ambition/ambitioncircle.svg';
import arrow from '../../../assets/shapes_svg/ambition/arrow-right.svg';
import { CustomCheckbox } from './SBTi';

import { useState, useEffect } from 'react';

const TargetValidation = () => {
    const [target, setTarget] = useState("");
    const [dropdownTarget, setDropdownTarget] = useState([
        {id:1, name:'50% from a 2018 base year',checked:false},
        {id:2, name:'46% from a 2019 base year',checked:false},
        {id:3, name:'42% from a 2020 base year',checked:false},
        {id:4, name:'42% from a 2021 base year',checked:false},
        {id:5, name:'42% from a 2022 base year',checked:false},
    ])

    return (
    <>
    <div>
        <div style={{display:"flex", justifyContent:"center"}}>
            <CustomCheckbox 
                states={dropdownTarget}
                setStates={setDropdownTarget}
                title=""
                target={target}
                setTarget={setTarget}
            />
        </div>
        <br/><br/>
        <h5 style={{textAlign:"center"}}>“ Our company commits to reduce absolute scope 1 and scope 2 GHG emissions {target.split(' ')[0]} by 2030 from a {target.split(' ')[3]} base year, and to measure and reduce its scope 3 emissions.”</h5>
        <div className="d-flex" style={{flexDirection:"row",alignItems:"center",justifyContent:"center",padding:"10px"}}>
            <div className="big__circle">
                <h6>xx tCO2e</h6>
            </div>
            <img className="arrow" src={arrow} alt=""/>
            <div className="small__circle">
                <h6>xx tCO2e</h6> 
            </div>
        </div>
    </div>
        
    </>
    )
}

export default TargetValidation;